module.exports = require("readline");


//////////////////
// WEBPACK FOOTER
// external "readline"
// module id = 1049
// module chunks = 0 1 3